import { FC } from "react";
import { useDevice } from "common/hooks/useDevice";
import { Avatar } from "./AuthorAvatar.styled";
import { AuthorsProps } from "../../types/Article.types";

interface Props {
  authors: AuthorsProps
}
const AuthorAvatar: FC<Props> = ({ authors }) => {
  const { screenSize } = useDevice();
  if (screenSize.medium || !authors || authors.length > 1) {
    return null;
  }
  const { imageUrl } = authors[0];
  if (!imageUrl) {
    return null;
  }
  return <Avatar src={imageUrl} alt="" />;
};
export default AuthorAvatar;
